import { createFileRoute } from "@tanstack/react-router";
import { VideoScanInfoPage } from "./videoskanning";

export const Route = createFileRoute("/es/escaneo-video")({
  head: () => ({
    meta: [
      { title: "Escaneo por vídeo – graba y obtén tu anuncio | Sellavo" },
      { name: "description", content: "Graba tu objeto y Sellavo convierte el vídeo en fotos, título, descripción y precio." },
      { property: "og:title", content: "Escaneo por vídeo – graba y obtén tu anuncio | Sellavo" },
      { property: "og:description", content: "Graba tu objeto y Sellavo convierte el vídeo en fotos, título, descripción y precio." },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/es/escaneo-video" }],
  }),
  component: VideoScanInfoPage,
});
